import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * The router leaves the scroll position exactly where the previous page left
 * it, so opening a course from halfway down the list dropped you halfway down
 * the course. Reset it on every forward navigation; a POP keeps whatever the
 * browser restored for back/forward, and a hash belongs to its anchor.
 */
function ScrollToTop() {
	const { pathname, hash } = useLocation();
	const navigationType = useNavigationType();

	useLayoutEffect(() => {
		if (navigationType === "POP" || hash) return;

		// `html` carries `scroll-behavior: smooth`, which would otherwise
		// animate the jump all the way up the page we are leaving.
		window.scrollTo({ top: 0, left: 0, behavior: "instant" });
	}, [pathname, hash, navigationType]);

	return null;
}

export default ScrollToTop;
